<template>
  <login-mobile
    :form-data-mapper="requestDataMapper"
    :submit-text="$t('scope.mobile_login_or_register')"
    @after-login="handleAfterLogin" />
</template>

<script>
import LoginMobile from '@/sections/Auth/Login/components/LoginMobile'

export default {
  name: 'LoginMobileWrap',
  components: {
    LoginMobile,
  },
  methods: {
    async handleAfterLogin () {
      try {
        if (this.$route.query) {
          const { source } = this.$route.query
          if (source === 'partner') {
            window.location.href = '/account'
          }
          if (source && source.substring(0, 4) === 'http') {
            window.location.href = source
          }
        }
        return true
      } catch (error) {
        throw error
      }
    },
    requestDataMapper (data) {
      if (this.$route.query.domain) {
        data.domain = this.$route.query.domain
        return data
      }
      return data
    },
  },
}
</script>
